import { Portefeuille } from "./../models/Portefeuille";
import { NgbdModalConfirm } from "./../services/modal-confirm";
import { ViewItemModalComponent } from "./../import-portefeuilles/importations/view-item-modal/view-item-modal.component";
import { AddItemModalComponent } from "./../import-portefeuilles/importations/add-item-modal/add-item-modal.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FondsPropresService } from "./../services/fonds-propres.service";
import { ImportPortefeuille } from "./../models/ImportPortefeuille";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";

@Component({
  selector: "app-portefeuilles",
  templateUrl: "./portefeuilles.component.html",
  styleUrls: ["./portefeuilles.component.scss"],
})
export class PortefeuillesComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator, { static: false })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: false })
  sort: MatSort;
  dataSource: MatTableDataSource<Portefeuille>;
  isLoadingResults = false;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = [
    "id",
    "libelle",
    "description",
    "nombreTotal",
    "nombreEcarts",
    "status",
    "createdDate",
    "createdBy",
    "actions",
  ];
  data: Portefeuille[] = [];

  constructor(
    private shared: FondsPropresService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getPortefeuilles();
  }

  getPortefeuilles() {
    this.isLoadingResults = true;
    this.shared.getPortefeuilles().subscribe(
      (data) => {
        this.data = data;
      },
      (error) => {
        console.log(error);
        this.isLoadingResults = false;
      },
      () => {
        if (this.data == null) {
          this.data = [];
        }
        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isLoadingResults = false;
      }
    );
  }

  ngAfterViewInit() {
    //this.dataSource.sort = this.sort;
    //this.dataSource.paginator = this.paginator;
  }

  viewItemModal(row) {
    const viewModalRef = this.modalService.open(ViewItemModalComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      scrollable: true,
      windowClass: "my-modal-class",
    });
    viewModalRef.componentInstance.portefeuille = row;

    viewModalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  refresh() {
    this.getPortefeuilles();
  }

  //delete specific
  deletePortefeuille(row) {
    //message en popup
    const modalConfirmRef = this.modalService.open(NgbdModalConfirm, {
      centered: true,
    });
    modalConfirmRef.componentInstance.title = "Suppression #" + row.id;
    modalConfirmRef.componentInstance.libelle = row.libelle;
    modalConfirmRef.componentInstance.queryMessage =
      "Etes-vous sûr de vouloir supprimer le dossier";
    modalConfirmRef.componentInstance.description =
      '<p>Toutes les informations associées à ce dossier seront définitivement supprimées. <span class="text-danger"> Cette opération sera définitive.</span>';
    modalConfirmRef.componentInstance.btnMessage = "Oui, supprimer";

    modalConfirmRef.result.then(
      (result) => {
        console.log("modalConfirmRefResult", result);
        // on close
        this.isLoadingResults = true;
        this.shared.deletePortefeuille(row.id).subscribe(
          (data) => {
            console.log(data);
            this.getPortefeuilles();
          },
          (error) => {
            this.isLoadingResults = false;
          },
          () => {
            this.isLoadingResults = false;
          }
        );
      },
      (reason) => {
        console.log("reason", reason);
        //on dismiss
      }
    );
  }
}
